/* global axios */
import ApiClient from './ApiClient';

class Status extends ApiClient {
  constructor() {
    super('status', { accountScoped: true });
  }

  get() {
    return axios.get(`${this.url}`);
  }
}

export default new Status();
